import { render, staticRenderFns } from "./ConfirmacionPresupuesto.vue?vue&type=template&id=69820884&scoped=true"
import script from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"
export * from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69820884",
  null
  
)

export default component.exports